"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = env;

// Returns "production" or "staging"
function env() {
  return typeof window !== 'undefined' ? /(^|\S+\.)mapbox\.com/.test(window.location.host) ? 'production' : 'staging' : undefined;
}